import { PerspectivesGroups } from './PerspectivesGroups';
import { KnowledgeBaseLink } from '@ardoq/knowledge-base';
import { GroupsTabProps } from '../types';
import { Island } from '@ardoq/page-layout';
import { t } from '@ardoq/i18n';

export const GroupsTab = (props: GroupsTabProps) => {
  return (
    <Island
      title={t(
        props.i18nLocale,
        'perspectives:groupsTab.title',
        'Group components'
      )}
      knowledgeBaseLink={KnowledgeBaseLink.GROUPING_RULES}
      subtitle={t(
        props.i18nLocale,
        'perspectives:groupsTab.subtitle',
        'Show component hierarchy and give a clearer view of how components relate to one another by grouping them based on different criteria.'
      )}
    >
      <PerspectivesGroups {...props} />
    </Island>
  );
};
